/**
 * Fill classes for the periodic table's colour modes.
 *
 * Every tile uses a light pastel fill with near-black text in both themes, so contrast is
 * the same in light and dark mode. The legend and every tile also print a short code, so
 * the colour is never the only way to read a class.
 */
export const CLASS_FILL: Record<string, string> = {
  alkali: "bg-rose-200",
  alkaline: "bg-orange-200",
  transition: "bg-amber-100",
  post: "bg-lime-200",
  metalloid: "bg-emerald-200",
  nonmetal: "bg-teal-200",
  halogen: "bg-cyan-200",
  noble: "bg-sky-200",
  lanthanide: "bg-indigo-200",
  actinide: "bg-fuchsia-200",
  blockS: "bg-rose-200",
  blockP: "bg-teal-200",
  blockD: "bg-amber-100",
  blockF: "bg-indigo-200",
  en1: "bg-orange-50",
  en2: "bg-orange-100",
  en3: "bg-orange-200",
  en4: "bg-orange-300",
  en5: "bg-orange-400",
  en6: "bg-orange-500",
  enNone: "bg-neutral-100",
  ancient: "bg-amber-200",
  before1800: "bg-lime-200",
  y1800s: "bg-teal-200",
  y1900a: "bg-sky-200",
  y1950: "bg-violet-200",
};

export const TILE_TEXT = "text-neutral-900";
